import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import HotelBookingDetails from "../components/HotelBookingDetails";

const HotelBooking = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Hotel Booking"} />

      {/* Service Details Area */}
      <HotelBookingDetails />


      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default HotelBooking;